<template>
  <div id="rawMaintain-EQ" class="page-container">
    <div class="status-card">
      <div>
        <el-button @click="loadCurrent">读取</el-button>
      </div>
      <div class="status-item">
        <span class="label">设备当前状态：</span>
        <span class="status-value" :class="cupMaintainSpan === 0 ? 'status-off' : 'status-on'">
          {{ cupMaintainSpan === 0 ? '未开启管控' : '已开启管控' }}
        </span>
      </div>
      <div class="status-item">
        <span class="label">设备当前使用杯数:</span>
        <span class="value">{{ initValue.currentCupQuantity }}</span>
      </div>
    </div>

    <div class="form-card">
      <div class="form-item">
        <span class="form-label">充值杯数:</span>
        <el-input
          v-model="form.setCupQuantity"
          class="form-input"
          type="number"
          :min="minCupQuantity"
          placeholder="请输入充值杯数">
        </el-input>
      </div>

      <div class="form-item">
        <span class="form-label">管控状态:</span>
        <el-select
          v-model="form.cupMaintain"
          class="form-select">
          <el-option :value=0 label="关闭"></el-option>
          <el-option :value=1 label="开启"></el-option>
        </el-select>
      </div>

      <div class="button-group">
        <el-button
          @click="saveData"
          type="primary"
          class="save-btn">
          保存
        </el-button>
      </div>
      <span>保存后请返回设备列表页面刷新页面，否则可能造成管控状态显示不正确的问题。</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "rawMaintain-EQ",
  props: {
    initValue: null
  },
  data(){
    return{
      form:{
        setCupQuantity:0,
        cupMaintain:0,
      },
      cupMaintainSpan:0,
      isLoadData:false,
      minCupQuantity: 0, // 最小杯数
    }
  },
  mounted(){
    this.cupMaintainSpan = this.initValue.cupMaintain
    this.setMinQuantity()
  },
  methods:{
    setMinQuantity() {
      this.minCupQuantity = this.initValue.currentCupQuantity || 0
      // 同时把输入框默认值设为最小值，体验更好
      this.form.setCupQuantity = this.minCupQuantity
    },
    saveData(){
      // 一定要先读取
      if(this.isLoadData === false){
        this.$message.error("请先读取！")
        return false
      }
      if(this.initValue.equipmentTypeId === 66){
        // 如果设置值小于当前值，不允许
        if(this.form.cupMaintain === 1 && this.form.setCupQuantity <=  this.initValue.currentCupQuantity){
          this.$message.error(`充值杯数不能小于当前杯数 ${this.minCupQuantity}`)
          return false
        }
        this.$httpservice.put("api/Equipment/UpdateRawMaintain",{cupMaintain:this.form.cupMaintain,setCupQuantity:this.form.setCupQuantity,id:this.initValue.id}).then(res=>{
          if(res.body.code === 200){
            this.cupMaintainSpan = this.form.cupMaintain
            this.$message.success("保存成功")
          }
        })
      }else{
        if(this.form.setCupQuantity === 0){
          this.form.cupMaintain = 0
        }
        this.$httpservice.put("api/Equipment/UpdateRawMaintain",{cupMaintain:this.form.cupMaintain,setCupQuantity:this.form.setCupQuantity,id:this.initValue.id}).then(res=>{
          if(res.body.code === 200){
            this.cupMaintainSpan = this.form.cupMaintain
            this.$message.success("保存成功")
          }
        })
      }
    },
    loadCurrent() {
      // 1. 开启加载
      this.reloading = this.openLoading("读取中........")
      // 如果是非东风机型，就需要先读取设备参数，获取到值之后进行显示
      if(this.initValue.equipmentTypeID === 66){
        this.$httpservice.get("api/Equipment/LoadRawMaintain?dtuNumber=" + this.initValue.dtuNumber)
          .then(res => {
            // 严格判断
            if (res && res.body.code === 200) {
              // 延迟 10 秒执行
              setTimeout(() => {
                // 关闭加载
                try {
                  this.reloading.close()
                } catch (e) {}

                this.$message.success("读取成功")

                // 调用第二个接口
                this.$httpservice.get("api/Equipment/Get?dtuNo=" + this.initValue.dtuNumber)
                  .then(res => {
                    if(res.body.code === 200){
                      this.initValue.currentCupQuantity = res.body.data.currentCupQuantity;
                      this.form.cupMaintain = res.body.data.cupMaintain
                      console.log("进入时",this.form.cupMaintain)
                      this.setMinQuantity(); // 读取成功后重新设置最小值
                    }
                  })
                  .catch(err => {
                    console.error("第二个接口报错：", err)
                  })
                this.isLoadData = true
              }, 10000)

            } else {
              // 没进 200
              console.log("=== 接口返回 code 不是 200 ===")
              this.reloading.close()
            }
          })
          .catch(err => {
            console.error("第一个接口报错：", err)
            this.reloading.close()
            this.$message.error("读取失败")
          })
      }else{
        // 读设备参数
        this.$httpservice.get("api/Equipment/ReadEquipmentParameters",{equipmentId:this.initValue.id})
          .then(res => {
            // 严格判断
            if (res && res.body.code === 200) {
              // 延迟 10 秒执行
              setTimeout(() => {
                // 关闭加载
                try {
                  this.reloading.close()
                } catch (e) {}

                this.$message.success("读取成功")

                // 调用第二个接口
                this.$httpservice.get("api/Equipment/GetParameters?dtuNo=" + this.initValue.dtuNumber)
                  .then(res => {
                    if(res.body.code === 200){
                      // 匹配参数中的SetSales_GEN*2#1
                      let temp = res.body.data;
                      let target = temp.find(function(item) {
                        return item.variableName === 'SetSales_GEN*2#1';
                      });
                      this.initValue.currentCupQuantity = target ? target.currentValue : 0;
                      console.log("获取到杯数是",target)
                      this.setMinQuantity(); // 读取成功后重新设置最小值
                    }
                  })
                  .catch(err => {
                    console.error("第二个接口报错：", err)
                  })
                this.isLoadData = true
              }, 10000)
            } else {
              // 没进 200
              console.log("=== 接口返回 code 不是 200 ===")
              this.reloading.close()
            }
          })
      }
    }
  }
}
</script>

<style lang="less" scoped>
#rawMaintain-EQ {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

// 状态卡片样式
.status-card {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.status-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: 14px;

  &:last-child {
    margin-bottom: 0;
  }
}

.label {
  color: #606266;
  margin-right: 10px;
  font-weight: 500;
}

.status-value {
  padding: 4px 10px;
  border-radius: 4px;
  font-weight: 500;
}

.status-on {
  background-color: #f0f9eb;
  color: #67c23a;
}

.status-off {
  background-color: #fef0f0;
  color: #f56c6c;
}

.value {
  color: #303133;
  font-weight: 500;
}

// 表单卡片样式
.form-card {
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 30px;
  }
}

.form-label {
  width: 80px;
  text-align: right;
  margin-right: 15px;
  color: #606266;
  font-size: 14px;
}

.form-input,
.form-select {
  width: 200px;
}

// 按钮样式
.button-group {
  display: flex;
  justify-content: flex-start;
  padding-left: 95px;
}

.save-btn {
  width: 120px;
  height: 40px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/equipmentmanagement/RawMaintain-EQ.vue